import React from "react";
import { Section, SectionHeading } from "@/components/layout/Section";
import { MicroLabel } from "@/components/common/MicroLabel";
import { Reveal } from "@/components/common/Reveal";
import { PROCESS_STEPS } from "@/content/homeContent";

export const Process = () => {
  return (
    <Section id="process-section" tone="dark">
      <Reveal>
        <SectionHeading
          microLabel="PROCESSO"
          title="Dal progetto al pezzo reale."
          description="Un percorso chiaro e controllato. Sai sempre a che punto sei e cosa succede dopo."
        />
      </Reveal>

      <div className="mt-14">
        <ol className="relative">
          {PROCESS_STEPS.map((step, i) => (
            <Reveal key={step.index} delay={i * 0.05}>
              <li
                data-testid={`process-step-${i}`}
                className="relative grid grid-cols-1 gap-4 border-l border-white/12 pb-10 pl-8 last:pb-0 md:grid-cols-12 md:gap-8"
              >
                {/* node */}
                <span className="absolute -left-[7px] top-1 h-3.5 w-3.5 rounded-full border border-white/25 bg-strato-nearblack">
                  <span className="absolute inset-1 rounded-full bg-strato-blue" />
                </span>

                <div className="md:col-span-4">
                  <MicroLabel className="text-white/40">STEP {step.index}</MicroLabel>
                  <h3 className="mt-2 font-display text-2xl font-medium tracking-[-0.01em] text-white">
                    {step.title}
                  </h3>
                  <MicroLabel className="mt-2 text-strato-blue">{step.meta}</MicroLabel>
                </div>
                <div className="md:col-span-7 md:col-start-6">
                  <p className="max-w-[56ch] text-[15px] leading-[1.65] text-white/70">
                    {step.description}
                  </p>
                </div>
              </li>
            </Reveal>
          ))}
        </ol>
      </div>
    </Section>
  );
};
